import { Stack, Typography } from "@mui/material";
import type { MembersChangeRequestView } from "../../../../../api/types/membersChangeRequestTypes";
import useSettingsContext from "../../../useSettingsContext";
import { getMemberChanges } from "../membersChangeRequestHelper";
import MemberChangesTable from "./MemberChangesTable";

interface Props {
  changeRequest: MembersChangeRequestView;
}

const MemberChangesSections = ({ changeRequest }: Props) => {
  const { accessCategories } = useSettingsContext();

  const changes = getMemberChanges(changeRequest, accessCategories);
  const addedChanges = changes.filter((change) => change.action === "CreateNew");
  const updatedChanges = changes.filter((change) => change.action === "UpdateExisting");
  const removedChanges = changes.filter((change) => change.action === "Delete");

  return (
    <>
      {addedChanges.length > 0 && (
        <Stack spacing={1.5}>
          <Typography variant="subtitle1">Adding new contact ({addedChanges.length})</Typography>
          <MemberChangesTable changes={addedChanges} />
        </Stack>
      )}
      {updatedChanges.length > 0 && (
        <Stack spacing={1.5}>
          <Typography variant="subtitle1">Updating contact ({updatedChanges.length})</Typography>
          <MemberChangesTable changes={updatedChanges} />
        </Stack>
      )}
      {removedChanges.length > 0 && (
        <Stack spacing={1.5}>
          <Typography variant="subtitle1">Removing contact ({removedChanges.length})</Typography>
          <MemberChangesTable changes={removedChanges} />
        </Stack>
      )}
    </>
  );
};

export default MemberChangesSections;
